module.exports = __webpack_public_path__ + "DINNextLTPro-LightItalic.eot?6cb15c1cb9be50d642e65b0cf6727b66";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-LightItalic.eot
// module id = 320
// module chunks = 0